import { Skeleton } from "@/components/ui/skeleton";

export const SidebarSkeleton = () => {
  return (
    <div className="mb-4">
      <div className="flex items-center gap-4 pl-2 pt-4 mb-1">
        <Skeleton className="h-6 w-6 rounded-full bg-card" />
        <Skeleton className="h-4 w-24 bg-card" />
      </div>
      <ul className="mb-4 pl-2 pr-4">
        {[1, 2, 3].map((i) => (
          <li key={i} className="flex items-center mb-1 px-3 rounded-xl gap-4">
            <Skeleton className="h-4 w-4 rounded bg-card" />
            <Skeleton className="h-4 flex-1 bg-card" />
            <Skeleton className="h-6 w-6 bg-card" />
          </li>
        ))}
      </ul>
    </div>
  );
};

